
import { FragmentNames, MyChartAllergiesAliases, TabMyChartAllergiesAliases } from '../../codegen';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import UserContext from '../../utils/user-context';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { AutocompleteAPI, FetchAPI, FieldAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent, MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { MyChartControlItems } from '../../constants/my-chart-tab-control-items';
import { MyChartFilterSituationEnumData } from '../../constants/my-chart-filter-status-enum';

interface Filters extends Record<string, Value>{
  dateDisable : string;
  dateSubmit : string;
  fromDate : string;
  statusObj : Autocomplete;
  untilDate : string;
}

interface Autocomplete extends Record<string, Value>{
  description: string;
  value: number;
}
@Controller({ fragment: FragmentNames.TAB_MY_CHART_ALLERGIES })
export default class MyChartTabAllergiesController extends BaseController {

  @Inject(TabMyChartAllergiesAliases.AUTOCOMPLETE_STATUS)
    autocompleteStatusAPI!: AutocompleteAPI;

  @Inject(TabMyChartAllergiesAliases.FETCH_MY_CHART_ALLERGIES)
    fetchAllergiesAPI!: FetchAPI;

  @Inject(TabMyChartAllergiesAliases.FIELD_STATUS)
    statusFilterFieldAPI!: FieldAPI;

  @Inject(TabMyChartAllergiesAliases.FILTER_ALLERGIES)
    filterAllergiesAPI!: FilterAPI;

  @OnClick({ target: TabMyChartAllergiesAliases.DECK_ALLERGIES })
  handleClickAllergieCard(event: ClickEvent): void {
    const { nrSequence } = event.value;
    const currentFetchTab =  this.context.get('currentTab');

    if (currentFetchTab === MyChartAllergiesAliases.TAB_HOSPITAL) {
      HttpService.post(APPLICATION_ENDPOINTS.POST_MC_HOSPITAL_ITENS_AS_READ, {
        myChartItem: MyChartControlItems.ALLERGIES,
        recordSequence: nrSequence
      });
    }

    applicationContext.redirect(APPLICATION_ROUTES.MY_CHART_ALLERGIE_DETAIL, {
      nrSequence: nrSequence,
      tab: currentFetchTab as string
    });
  }

  @OnMount(TabMyChartAllergiesAliases.AUTOCOMPLETE_STATUS)
  onMountAutocompleteStatus(event: MountEvent): void {
    const currentFetchTab =  this.context.get('currentTab');
    const statusAutocomplete = event.target as AutocompleteAPI;
    const isHospital = currentFetchTab === MyChartAllergiesAliases.TAB_HOSPITAL;

    statusAutocomplete.setClearable(!isHospital);
    statusAutocomplete.setEnabled(!isHospital);

    const fillStatus = [
      {'description': MessageService.translate(MyChartFilterSituationEnumData.active), 'value': MyChartFilterSituationEnumData.activeCode},
      {'description': MessageService.translate(MyChartFilterSituationEnumData.inactive), 'value': MyChartFilterSituationEnumData.inactiveCode},
      {'description': MessageService.translate(MyChartFilterSituationEnumData.released), 'value': MyChartFilterSituationEnumData.releasedCode},
      {'description': MessageService.translate(MyChartFilterSituationEnumData.notReleased), 'value': MyChartFilterSituationEnumData.notReleasedCode}
    ] as unknown as Record<string, Value>[];

    statusAutocomplete.setData(fillStatus);
  }

  @OnMount(TabMyChartAllergiesAliases.FILTER_ALLERGIES)
  onMountFilterAllergie(event: MountEvent): void {
    const filter = event.target as FilterAPI;
    const currentFetchTab =  this.context.get('currentTab') as string;

    const isHospital = currentFetchTab === MyChartAllergiesAliases.TAB_HOSPITAL;
    const code = isHospital ? MyChartFilterSituationEnumData.releasedCode : MyChartFilterSituationEnumData.activeCode;
    const description = isHospital ? MyChartFilterSituationEnumData.released : MyChartFilterSituationEnumData.active;

    filter.setData({
      fromDate: '',
      statusObj: {
        description: description,
        value: code
      },
      untilDate: ''
    });
    filter.submit();
  }

  @OnMount(TabMyChartAllergiesAliases.FETCH_MY_CHART_ALLERGIES)
  onMountFetchMyChartAllergies(event: MountEvent): void {
    const filters = {} as Filters;
    const fetchAPI = event.target as FetchAPI;
    fetchAPI.setEndpoint(APPLICATION_ENDPOINTS.GET_MC_ALLERGIES);
    this.getAllergies(filters);
  }

  @OnSubmit(TabMyChartAllergiesAliases.FILTER_ALLERGIES)
  OnSubmitAllergie(event: SubmitEvent): void {
    const filters = event.record as Filters;
    this.getAllergies(filters);
  }

  getAllergies(filters?: Filters): void {
    const currentFetchTab =  this.context.get('currentTab') as string;

    if (!currentFetchTab) {
      return;
    }
    const isHospital = currentFetchTab === MyChartAllergiesAliases.TAB_HOSPITAL;
    const code = isHospital ? MyChartFilterSituationEnumData.releasedCode : MyChartFilterSituationEnumData.activeCode;

    this.fetchAllergiesAPI.setParameters(this.getFetchParameters(currentFetchTab, code, filters));
    this.fetchAllergiesAPI.forceFetch();
  }

  getFetchParameters(currentFetchTab: string, code?: string, filters?: Filters): Record<string, Value> {
    const statusValue = filters?.statusObj?.value ? filters.statusObj.value : code;
    const fromDateValue = filters?.fromDate ? filters.fromDate : '';
    const untilDateValue = filters?.untilDate ? filters.untilDate : '';
    return {
      fromDate: fromDateValue,
      patientId: UserContext.patientId,
      status: statusValue,
      tab: currentFetchTab,
      untilDate: untilDateValue
    };
  }
}